import { render, staticRenderFns } from "./EmailEdition.vue?vue&type=template&id=1b22b97c"
import script from "./EmailEdition.vue?vue&type=script&lang=js"
export * from "./EmailEdition.vue?vue&type=script&lang=js"
import style0 from "./EmailEdition.vue?vue&type=style&index=0&id=1b22b97c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports